import React from 'react'
import styled from 'styled-components'
import { rhythm, media } from '../utils/typography'
import { withTranslation } from 'react-i18next'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Section from '../components/section'
import Link from '../components/link'
import Date from '../components/date'

export default styled(withTranslation()(({ className, t, pageContext }) => {
  const { article, html } = pageContext
  return (
    <Layout className={className}>
      <SEO title={article.title} />

      <Section title={t('articles.title')}>
        <article>
          <header><h1>{article.title}</h1></header>
          {article.author ?
            <section className='author'>{article.author}</section>
          : null}
          {article.date ?
            <section className='date'><Date date={article.date} /></section>
          : null}
          <section dangerouslySetInnerHTML={{ __html: html }} />
        </article>

        <footer>
          <Link to='/news'>&laquo;&nbsp;{t('articles.title')}</Link>
        </footer>
      </Section>
    </Layout>
  )
}))`
  h1 {
    margin: ${rhythm(1/3)} 0 ${rhythm(1/4)};
    ${media.tablet} { margin: ${rhythm(1/2)} 0 ${rhythm(1/3)} }
  }

  .author, .date {
    font-size: 0.7em;
    margin: ${rhythm(1/4)} 0 ${rhythm(1/2)};
    ${media.tablet} {
      font-size: 0.8em;
      margin: ${rhythm(1/3)} 0 ${rhythm(1/2)};
    }
    ${media.desktop} {
      font-size: 0.9em;
      margin: ${rhythm(1/2)} 0;
    }
    font-style: italic;
  }

  footer {
    margin: ${rhythm(1/4)} 0 ${rhythm(1)};
  }
`
